import currencyFormatter from './currencyFormatter';

function feeFormatter(value = 0, showPositive: boolean): string {
  if (value === 0) return 'Free';
  const formatted = currencyFormatter(value);
  return showPositive ? formatted : `- ${formatted}`;
}

export default feeFormatter;
